/** "What happens if you miss a pay-later payment on a flight": metadata (the article is in ../bodies/missed-pay-later-payment-on-a-flight.js). */
export default {
  slug: 'missed-pay-later-payment-on-a-flight',
  category: 'Pay over time',
  title: 'What happens if you miss a pay-later payment on a flight',
  seoTitle: 'Missed a Pay-Later Payment on a Flight? (2026)',
  description: 'Missed an Affirm, Klarna, Afterpay, PayPal or Uplift payment on a flight? Late fees, credit reporting, collections and what happens to your trip.',
  dek: 'Late fees, retries, credit reporting and collections work differently at every buy now, pay later provider. Here is what a missed payment really costs, what happens to the flight, and how to get back on track.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'Does Affirm charge a late fee if I miss a payment?',
      a: 'No. As of November 2026 Affirm charges no late fees on any plan. It reports its loans to Experian and TransUnion, though, and outstanding payments count against you when you apply for another Affirm loan.',
    },
    {
      q: 'How much is Klarna’s late fee?',
      a: 'Under Klarna’s US Pay in 4 agreement, a payment still unpaid 10 days after its due date can incur a late fee of up to $7. Late fees on one order never total more than 25% of the purchase amount.',
    },
    {
      q: 'If I cancel my flight, do I still have to pay the BNPL loan?',
      a: 'Yes, until a refund reaches the lender. A refund goes back to the loan and lowers your balance, but if you cancel a non-refundable fare and receive an airline credit instead, the loan balance stays the same and payments continue.',
    },
    {
      q: 'Can a missed BNPL payment cancel my flight?',
      a: 'Generally no. The lender paid the airline in full at checkout, so a missed payment is a problem with the loan, handled through fees where allowed, interest, credit reporting or collections. Check the travel seller’s terms too, especially for packages.',
    },
    {
      q: 'When does a missed BNPL payment show up on my credit report?',
      a: 'Creditors generally report a late payment only once it is at least 30 days past due. Once reported, it stays on your credit report for seven years from the date you missed it.',
    },
    {
      q: 'What happens if I miss a Defera payment?',
      a: 'Your trip isn’t cancelled on the spot. The payment shows as past due, there’s no late fee for the missed payment itself, and you can catch up from Make a Payment from $5 at a time or move the payment to a later day for an Extension Fee.',
    },
  ],
  related: [
    'does-buy-now-pay-later-affect-credit-score',
    'flight-layaway-vs-bnpl',
    'flight-payment-plans-no-credit-check',
  ],
};
